import type { IStepperStep } from "@front-shared/types/objects.types"

import { ClientDataStep } from "../components/intakeDemo/steps/clientData.step"
import { InsuranceDataStep } from "../components/intakeDemo/steps/insuranceData.step"
import { ReasonStep } from "../components/intakeDemo/steps/reason.step"

export const STEPPER_CONFIG = {
    intakeDemoInitial: [
        {
            key: "reasonData",
            stepComponent: ReasonStep,
        },
        {
            key: "clientData",
            stepComponent: ClientDataStep,
        },
    ] as IStepperStep[],

    intakeDemoPayer: [
        {
            key: "insuranceData",
            stepComponent: InsuranceDataStep,
        },
    ] as IStepperStep[],
}
